(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provider-tr', {
            parent: 'entity',
            url: '/provider-tr?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.provider_tr.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider-tr/provider-trs.html',
                    controller: 'Provider_trController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider_tr');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('provider-tr-detail', {
            parent: 'provider-tr',
            url: '/provider-tr/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY'],
                pageTitle: 'uniromaLandingApp.provider_tr.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provider-tr/provider-tr-detail.html',
                    controller: 'Provider_trDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provider_tr');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Provider_tr', function($stateParams, Provider_tr) {
                    return Provider_tr.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'provider-tr',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('provider-tr-detail.edit', {
            parent: 'provider-tr-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-tr/provider-tr-dialog.html',
                    controller: 'Provider_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provider_tr', function(Provider_tr) {
                            return Provider_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider-tr.new', {
            parent: 'registryEntities',
            url: '/provider-tr/{id}/new',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Provider', function($stateParams, $state, $uibModal,Provider) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-tr/provider-tr-dialog.html',
                    controller: 'Provider_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                field: null,
                                value: null,
                                language: null,
                                id: null,
                                provider: Provider.get({id : $stateParams.id})
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('registryEntities');
                });
            }]
        })
        .state('provider-tr.edit', {
            parent: 'registryEntities',
            url: '/provider-tr/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-tr/provider-tr-dialog.html',
                    controller: 'Provider_trDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provider_tr', function(Provider_tr) {
                            return Provider_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null);
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provider-tr.delete', {
            parent: 'registryEntities',
            url: '/provider-tr/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_REGISTRY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provider-tr/provider-tr-delete-dialog.html',
                    controller: 'Provider_trDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Provider_tr', function(Provider_tr) {
                            return Provider_tr.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registryEntities', null,{reload:'registryEntities'});
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
